import { FC } from 'react';

import { JabraIcon, useFallbackTranslation } from '@gn-audio/jss-components';

import pauseCircle from 'assets/icons/pauseCircle.svg';
import playCircle from 'assets/icons/playCircle.svg';
import { SoundPlayerProps } from 'components/Product/SoundDemo/soundDemoTypes';

export const SoundDemoPlayer: FC<SoundPlayerProps> = ({ isPlaying, onToggle }) => {
  const { t } = useFallbackTranslation();

  return (
    <button
      className="flex h-16 w-full items-center justify-center gap-2 p-2 focus-visible:rounded-full focus-visible:outline-none focus-visible:outline-offset-0 focus-visible:outline-focus"
      onClick={onToggle}
      data-wt-name={isPlaying ? 'Pause' : 'Play'}
    >
      <JabraIcon Icon={isPlaying ? pauseCircle : playCircle} />
      <span className="truncate text-left capitalize">
        {t(isPlaying ? 'system.PauseDemo' : 'system.PlayDemo')}
      </span>
    </button>
  );
};
